/* eslint-disable react-hooks/exhaustive-deps */
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { Border, CURVE_TYPE, CurveContent, ICurveDot, IScreenPosition, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { ICardProps } from "../Card"
import { useEffect, useMemo, useState } from "react"
import { Color } from "src/libs/interfaces/layouts"
import Curve from "../../../primitive/Curve"

/* Protopia Ecosystem component */ 
const CardBorderCurve = (props: ICardProps): JSX.Element => {
    const {data, section, contentData} = props
    const sizes = useScreenSize()
    const border: Border = contentData.border
    const border_radius: number[] = useMemo<number[]>(() => {
            return Array.isArray(contentData.border_radius)
                ?
                contentData.border_radius
                :
                Array(4).fill("").map(() => contentData.border_radius || 2)
        }, [contentData.border_radius])
    const gap = contentData.gap || 0
    const [w, setW] = useState<number>( 0 )
    const [h, setH] = useState<number>( 0 )
    const [top, setTop] = useState<number>( 0 )
    const [left, setLeft] = useState<number>( 0 )
    const [round, setRound] = useState<number[]>( border_radius )
    const strokeW: number = border?.strokeWidth || 0
    const color: Color = border?.stroke || ""
     useEffect(() => {
            setTimeout(() => {
                const selector = `.landing-card-body-${data.id}`
                const elem: Element = document.querySelector(selector)!
                if(!!elem) {
                    const bounds: DOMRect = elem?.getBoundingClientRect() || {}             
                    const style = window.getComputedStyle( elem )
                    setTop( parseInt(style.getPropertyValue('margin-top')) || 0 ) 
                    setW(bounds.width)
                    setH(bounds.height)
                }
            }, 100)
        }, [ sizes ])    
    
    const shiftX = -gap / 4 
    const shiftY = -gap / 4 
    const x = -shiftX - strokeW 
    const y = -shiftY - strokeW
    const svgWidth  = w + strokeW * 2
    const svgHeight = h + strokeW * 2 
    return <Curve
        primitive={{  
            id : data.id,
            position: {
                left:   x,
                top:    y,
                width:  svgWidth,
                height: svgHeight,
            } as IScreenPosition,
            bg: "transparent" ,
            fill: "transparent",
            color,
            strokeW,    
            isClosed: !!props.contentData.border?.isClosed,       
            path: props.contentData.border?.path || [],
            className: "untouchble position-absolute z-index-3 "
        } as any}
    />
}
export default CardBorderCurve